import { ShowSnackBar } from "event-definitions"

export function successSnackbar(message, options = {}) {
    ShowSnackBar.raiseLater(message, { variant: "success", ...options })
}
